<template>
    <Quantity
        :min="min"
        :defaultQuantity="defaultQuantity"
        :disableQuantity="field.product.disableQuantity"
        v-on:filled-out="$emit('filled-out',$event)"
    >
    </Quantity>
</template>

<script>
  import Quantity from './Quantity';

  export default {
    props: {
      field: {},
      value: '',
    },
    data() {
        return {
            'min' : 0
        };
    },
    created() {
        if (this.defaultQuantity > 0) {
            this.$emit('filled-out', this.defaultQuantity);
        }
    },
    components: {
        Quantity
    },
    computed: {
        defaultQuantity() {
            return this.field.product.disableQuantity ? 1 : 0;
        }
    }
  };
</script>
